import { createStore } from "vuex";
// 然后给 actions 注册一个事件处理函数，当这个函数被触发时，将状态提交到 mutaions中处理
import actions from "./actions";
// 更新状态
import mutations from "./muations";
// 获取状态信息
import getters from "./getters";
// 首先声明一个状态 state
const state = {
  msg: "test",
  isLoading: false,
  //用户信息
  userData: null,
  // userData:{openid: "ofw7W01l0txBMIQcUwXSZPXw1NGo"},//微信环境
  // userData:{openid: "BBDE6C87-E900-5A71-31CD-9BD9E7A1F895"},//app环境
};

export default createStore({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  modules: {},
});
